import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { useWishlist } from '../../context/WishlistContext';
import ProductCard from '../../components/shop/ProductCard';

const WishlistPage = () => {
  const { wishlist } = useWishlist();

  return (
    <div style={{ paddingTop: '72px', minHeight: '100vh' }}>
      <div style={{ background: 'var(--dark)', padding: '40px 0', borderBottom: '1px solid var(--border)' }}>
        <div className="container">
          <p style={{ fontSize: '10px', letterSpacing: '0.3em', color: 'var(--gold)', marginBottom: '8px' }}>SAVED</p>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '40px', fontWeight: 400 }}>My Wishlist</h1>
          <p style={{ color: 'var(--white-dim)', fontSize: '13px', marginTop: '6px' }}>{wishlist.length} item{wishlist.length !== 1 ? 's' : ''}</p>
        </div>
      </div>
      <div className="container" style={{ paddingTop: '48px', paddingBottom: '80px' }}>
        {wishlist.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '80px 20px' }}>
            <Heart size={64} color="var(--border)" style={{ marginBottom: '24px' }} />
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '28px', fontWeight: 400, marginBottom: '12px' }}>Your wishlist is empty</h2>
            <p style={{ color: 'var(--white-dim)', marginBottom: '24px' }}>Save your favorite fragrances to revisit later</p>
            <Link to="/collection" style={{ background: 'var(--gold)', color: 'var(--black)', padding: '12px 32px', fontSize: '11px', fontWeight: 700, letterSpacing: '0.2em' }}>EXPLORE COLLECTION</Link>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '24px' }}>
            {wishlist.map(p => <ProductCard key={p._id} product={p} />)}
          </div>
        )}
      </div>
    </div>
  );
};

export default WishlistPage;
